import { IntegrationService } from "./../integration.service";
import { put, select } from "redux-saga/effects";
import { getHubspotDataFailure, getHubspotDataSuccess } from "../actionCreators";

export function* handleGetHubspotData() {
    try {
        const formId: string = yield select(state => state.forms.current._id);
        const { data } = yield IntegrationService.getHubspotData(formId);
        yield put(getHubspotDataSuccess(data));
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || "Failed to get Hubspot data";
        yield put(getHubspotDataFailure(errorMessage));
    }
}
